import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const HeardAboutYoga = lazyWithPreload(() => import('./HeardAboutYoga'))
export const HeardAboutYogaForIntroPlan = lazyWithPreload(
  () => import('./HeardAboutYogaForIntroPlan'),
)
